import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { StyleProvider } from "@ant-design/cssinjs";
import ErrorPage from "./Error-page";
import UiKit from "./shared/UI kit/UIkit";
import { MapMarkerForm } from "./map-marker/Map-marker-form";
import EmbedMapWrapper from "./embed/embed-map/embed-map";
import { useMatomo } from "./map-marker/useMatomo";

const router = createBrowserRouter([
	{ path: "/", element: <App />, errorElement: <ErrorPage /> },
	{ path: "/UIkit", element: <UiKit />, errorElement: <ErrorPage /> },
	{ path: "/mini", element: <MapMarkerForm />, errorElement: <ErrorPage /> },
	{ path: "/public", element: <EmbedMapWrapper />, errorElement: <ErrorPage /> },
]);

function Root() {
	useMatomo(); // ✅ this runs once on mount
	return (
		<StyleProvider hashPriority="high">
			<RouterProvider router={router} />
		</StyleProvider>
	);
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<Root />);
